// client\src\hooks\useCourse.js
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getCourseBySlug } from "../services/courseService";

/**
 * Hook to fetch a single course by slug
 */
export const useCourseDetails = () => {
    const { courseSlug } = useParams();
    const [course, setCourse] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchCourse = async () => {
            try {
                if (courseSlug) {
                    const data = await getCourseBySlug(courseSlug);
                    setCourse(data);
                }
            } catch (err) {
                setError(err.message || "Failed to load course details.");
            } finally {
                setLoading(false);
            }
        };
        fetchCourse();
    }, [courseSlug]);

    return { course, loading, error };
};
